export function verif(rows, month, AN) {
  const array = [];
  let colClient = 0; // première colonne
  let colCodeArticle = 0;
  let colDesignation = 0;
  let colQuantite = 0;
  let colDateLivraison = 0;
  let colCodeClient = 0;
  let head = false;
  let test = false;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    const row = rows[rowIndex];
    const lowerRow = row.map(val => val.toString().toLowerCase());
    // Détection de l'en-tête
    if (!head && lowerRow.includes("code") && lowerRow.includes("code article") && lowerRow.includes("désignation") && lowerRow.includes("date livraison")) {
      colCodeClient = lowerRow.indexOf("code");
      colCodeArticle = lowerRow.indexOf("code article");
      colDesignation = lowerRow.indexOf("désignation");
      colQuantite = lowerRow.indexOf("quantité");
      colDateLivraison = lowerRow.indexOf("date livraison");
      colClient = lowerRow.indexOf("client");
      head = true;
      test = true;
      continue;
    }

    if (!head) continue;

    const client = row[colClient];
    const code_client = row[colCodeClient];
    const codeArticle = row[colCodeArticle];
    const designation = row[colDesignation];
    const quantite = row[colQuantite];
    const dateLivraisonRaw = row[colDateLivraison];
    let datee2 = null;

    if (typeof dateLivraisonRaw !== "string") {
      const excelDays = Number(dateLivraisonRaw);
      const excelStartDate = new Date(1900, 0, 1);
      const actualDate = new Date(
        excelStartDate.getTime() + (excelDays - 2) * 24 * 60 * 60 * 1000
      );
      datee2 = actualDate.toLocaleDateString("fr-FR");
    } else {
      datee2 = dateLivraisonRaw;
    }

  

    let dateLivraison;
    if (typeof datee2 === "string" && datee2.includes("/")) {
      const [day, month, year] = datee2.split("/").map(Number);
      dateLivraison = new Date(year, month - 1, day); // months are 0-based
    } else {
      dateLivraison = new Date(datee2); // fallback if it's already a date or ISO
    } // Now parsed correctly


    if (isNaN(dateLivraison)) continue;

    const mois = dateLivraison.getMonth() + 1;
    const annee = dateLivraison.getFullYear();
    if (mois == month && annee == AN) {
      if (typeof codeArticle === "string" && codeArticle.trim().endsWith("M")) {
        continue; // Skip codes ending with M°
      }

      array.push({
        client: client,
        code_client: code_client,
        code: codeArticle,
        designation: designation,
        valeur: quantite,
        dateLivraison: dateLivraisonRaw
      });
    }
  }
  return { array, test };
}
